<template>
  <v-container id="modificadores" tag="section">
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="grey" dark class="mb-2 mr-4" @click="goBack"
          >Volver</v-btn
        >
        <v-btn
          color="success"
          dark
          class="mb-2"
          @click="save"
          :loading="loadingGuardar"
          >Guardar</v-btn
        >

        <!-- <v-btn color="info" dark class="mb-2 ml-4" @click="adaptarOpciones"
          >Adaptar opciones</v-btn
        > -->
      </v-toolbar>
      <v-row dense class="pa-0">
        <v-col cols="12">
          <v-alert dense type="info" class="black--text">
            Este grupo lo utilizan
            <strong> {{ productosUtilizanGrupo }}</strong></v-alert
          ></v-col
        >
      </v-row>
      <v-card-text>
        <h3>{{ title }}</h3>
        <v-spacer />
        <v-row align="center">
          <v-col cols="12" md="3">
            <v-btn small color="primary" @click="addOpcionBoton"
              >Añadir Panel existente</v-btn
            >
          </v-col>
          <v-col cols="12" md="3">
            <v-btn small color="primary" @click="addOpcionBotonNuevo"
              >Crear Panel nuevo</v-btn
            >
          </v-col>
        </v-row>
        <v-card elevation="100">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="grupoModificador.nombre"
                  label="Nombre interno"
                  autofocus
                ></v-text-field> </v-col
              ><v-col cols="12" md="8">
                <v-text-field
                  v-model="grupoModificador.descripcion"
                  label="Descripción interna"
                  autofocus
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title> Modificadores </v-card-title>
          <v-list>
            <v-list-item>
              <v-list-item-title
                >Mostrar siempre en TPV<v-list-item-subtitle
                  >Aunque no haya opciones obligatorias, la secuencia se
                  mostrará en TPV
                </v-list-item-subtitle></v-list-item-title
              >

              <v-list-item-action
                ><v-checkbox
                  v-model="grupoModificador.mostrarSiempreTpv"
                ></v-checkbox></v-list-item-action></v-list-item
          ></v-list>
          <v-item-group>
            <v-container grid-list-md>
              <v-row>
                <draggable
                  tag="div"
                  class="row"
                  v-model="grupoModificador.modificadores"
                >
                  <v-col
                    v-for="(item, i) in grupoModificadorComputed"
                    :key="i"
                    cols="12"
                    md="4"
                  >
                    <v-item>
                      <v-card
                        slot-scope="{ active }"
                        :color="active ? 'primary' : ''"
                        elevation="100"
                      >
                        <v-toolbar color="secondary" dark>
                          <v-toolbar-title class="white--text">
                            <h4>
                              {{ item.nombre }} | <span>{{ item.tipo }}</span>
                            </h4>

                            <h6>
                              {{ item.descripcionInterna }} |
                              <v-icon @click="goModificador(item)"
                                >mdi-open-in-new</v-icon
                              >
                              <template v-if="item.mostrarCheck">
                                |
                                <v-icon
                                  @click="marcarIncompatiblesNinguno(item)"
                                  >mdi-checkbox-multiple-blank-outline</v-icon
                                >
                                |
                                <v-icon @click="marcarIncompatiblesTodos(item)"
                                  >mdi-checkbox-multiple-marked-outline</v-icon
                                >
                              </template>
                              |
                              <v-icon
                                @click="marcarVisualTodos(item)"
                                color="success"
                                >mdi-eye</v-icon
                              >
                              |
                              <v-icon
                                @click="marcarVisualNinguno(item)"
                                color="danger"
                                >mdi-eye</v-icon
                              >
                            </h6>
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-list>
                          <v-list-item
                            dense
                            v-for="(op, i_a) in item.opciones"
                            :key="i_a"
                          >
                            <template>
                              <v-list-item-icon
                                style=" cursor: pointer; }"
                                v-if="op.linkPre"
                                @click="marcarComp(op)"
                              >
                                <v-icon
                                  v-if="op.linkColor == 'green'"
                                  color="green"
                                  >mdi-link-variant</v-icon
                                >
                                <v-icon v-else color="red"
                                  >mdi-link-variant-off</v-icon
                                >
                              </v-list-item-icon>
                              <v-list-item-content
                                :class="
                                  keyManejando &&
                                  keyManejando.i_panel == i &&
                                  keyManejando.i_opcion == i_a
                                    ? 'info'
                                    : ''
                                "
                                @click="compaMarcarOpcion(i, i_a, op)"
                              >
                                <v-list-item-title
                                  ><v-list-item-icon>
                                    <v-checkbox
                                      dense
                                      hide-details=""
                                      text
                                      x-small
                                      color="red"
                                      :input-value="op.defecto"
                                      @click.stop="marcarDefecto(item, i, i_a)"
                                      class="mr-2"
                                    >
                                    </v-checkbox> </v-list-item-icon
                                  >{{ op.nombre }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                  v-text="op.descripcionInterna"
                                />
                                <v-list-item-subtitle>{{
                                  op.id
                                }}</v-list-item-subtitle>
                                <!-- <v-list-item-subtitle>{{
                                  op.incompatibilidades.join(",")
                                }}</v-list-item-subtitle> -->
                              </v-list-item-content>

                              <v-list-item-icon
                                @click="marcarOcultar(op, i, i_a)"
                              >
                                <v-icon v-if="op.ocultar" color="red"
                                  >mdi-eye</v-icon
                                >
                                <v-icon v-else color="green">mdi-eye</v-icon>
                              </v-list-item-icon>
                              <v-list-item-icon
                                v-if="op.linkPost"
                                @click="marcarComp(op)"
                              >
                                <v-icon
                                  v-if="op.linkColor == 'green'"
                                  color="green"
                                  >mdi-link-variant</v-icon
                                >
                                <v-icon v-else color="red"
                                  >mdi-link-variant-off</v-icon
                                >
                              </v-list-item-icon>
                            </template>
                          </v-list-item>
                          <v-card-actions>
                            <v-btn
                              small
                              color="red"
                              @click="borrarModificador(i)"
                              >BORRAR</v-btn
                            >
                          </v-card-actions>
                        </v-list>
                      </v-card>
                    </v-item>
                  </v-col>
                </draggable>
              </v-row>
            </v-container>
          </v-item-group>
        </v-card>
      </v-card-text>
      <v-dialog v-model="dialogAddOpcion" max-width="300">
        <v-card>
          <v-card-title>Añadir Panel Modificador</v-card-title>
          <v-card-text>
            <v-autocomplete v-model="opcionAdd" :items="modificadores">
            </v-autocomplete>
            <v-autocomplete
              label="configuracion"
              :items="secuenciasDisponiblesModificador"
              v-model="opcionAddConfiguracion"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn small color="success" @click="addOpcionConfirmar"
              >Añadir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddOpcionNuevo" max-width="300">
        <v-card>
          <v-card-title>Crear Panel Modificador</v-card-title>
          <v-card-text>
            <v-text-field
              label="Descripcion interna"
              v-model="opcionAddNuevo.descInterna"
            />
            <v-autocomplete
              v-model="opcionAddNuevo.basado"
              :items="modificadoresNuevos"
              label="Basado en "
            >
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn small color="success" @click="addOpcionConfirmarCrear"
              >Añadir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma, randomString } from "@/utils/utils.js";
import draggable from "vuedraggable";
import Sortable from "sortablejs";
export default {
  components: {
    draggable,
  },
  data() {
    return {
      opcionAddConfiguracion: null,
      keyManejando: null,
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      loadingGuardar: false,
      loading: false,
      colores: ["yellow", "red", "blue", "purple", "green", "pink"],
      dialogAddOpcion: false,
      dialogAddOpcionNuevo: false,
      opcionAddNuevo: {
        descInterna: "",
        basado: null,
      },
      opcionAdd: null,
      fieldEdicionNombreShow: "",
      fieldEdicionOpcionShow: "",
      accion: "configurar",
      editando: false,
      headersBase: [
        {
          sortable: false,
        },
        {
          text: "Nombre",
          value: "nombre",
        },
      ],
      grupoModificador: {
        id: null,
        nombre: "",
        descripcion: "",
        modificadores: [],
      },
    };
  },
  watch: {
    "opcionAddNuevo.basado"(v) {
      this.opcionAddNuevo.descInterna = v ? v.descripcionInterna : "";
    },
  },
  computed: {
    secuenciasDisponiblesModificador() {
      return [
        { text: "Predeterminado", value: null },
        ...this.$store.state.productos.gruposModificadores
          .filter((g) => {
            return (
              this.opcionAdd &&
              Array.isArray(g.modificadores) &&
              g.modificadores.map((m) => m.id).includes(this.opcionAdd.id)
            );
          })
          .map((g) => {
            return {
              ...g,
              text: g.nombre,
              value: g.id,
            };
          }),
      ];
    },
    productosUtilizanGrupo() {
      return this.productosBruto
        .filter(
          (p) =>
            !!p.individualPedible &&
            p.grupoModificador == this.grupoModificador.id
        )
        .map((p) => p.nombreMostrar)
        .join(", ");
    },
    headers() {
      return [
        ...this.headersBase,
        ...this.tarifas
          .map((t) => {
            return [
              {
                sortable: false,
                text: t.nombre + " Activo",
                value: "activo",
              },
              {
                sortable: false,
                text: t.nombre + " Precio global",
                value: "aceptarPrecioGlobal",
              },
              {
                sortable: false,
                text: t.nombre + " Precio",
                value: "precio",
              },
            ];
          })
          .flat(),
      ];
    },
    tarifasSelect() {
      return this.tarifas.map((t) => {
        return {
          text: t.nombre,
          value: t.id,
        };
      });
    },
    nombrePanel: {
      get() {
        this.langSeleccionado;
        return this.modificador.nombre.length > 0
          ? this.modificador.nombre.find((n) => n.lang == this.langSeleccionado)
              .text
          : "";
      },
      set(v) {
        let f = this.modificador.nombre.findIndex(
          (n) => n.lang == this.langSeleccionado
        );
        if (f > -1) this.modificador.nombre[f].text = v;
      },
    },
    descripcionPanel: {
      get() {
        return this.modificador.descripcion.length > 0
          ? this.modificador.descripcion.find(
              (n) => n.lang == this.langSeleccionado
            ).text
          : "";
      },
      set(v) {
        let f = this.modificador.descripcion.findIndex(
          (n) => n.lang == this.langSeleccionado
        );
        if (f > -1) this.modificador.descripcion[f].text = v;
      },
    },
    nombrePanelLabel() {
      return "Nombre panel " + this.langSeleccionado;
    },
    descripcionPanelLabel() {
      return "Descripción panel " + this.langSeleccionado;
    },
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    title() {
      let res = "";
      switch (this.accion) {
        case "configurar":
          res = "Construir producto";
          break;
        case "compatibilidad":
          res = "Manejar compatibilidades";
          break;
        case "mapeo":
          res = "Manejar mapeo Neo";
          break;
      }
      return res;
    },
    isConfigurar() {
      return this.accion !== "configurar";
    },
    ...mapGetters({
      negocio: "app/negocioGestObj",
      productosBruto: "productos/productosListadoTodos",
    }),
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      productos: (state) => state.productos.productosArray,
      tarifas: (state) => state.productos.tarifas,
    }),
    modificadores() {
      return this.$store.state.productos.modificadores.map((p) => {
        return {
          text: p.descripcionInterna,
          value: p,
        };
      });
    },
    modificadoresNuevos() {
      return [{ text: "Crear vacío", value: null }, ...this.modificadores];
    },
    grupoModificadorComputed() {
      let modificadores = this.$store.state.productos.modificadores;
      let opciones = this.productos.filter((p) => p.modificador);
      let res = this.grupoModificador.modificadores.map((g, i) => {
        let foundPanel = modificadores.find((m) => m.id == g.id);
        if (foundPanel) {
          //eliminamos las opciones grabadas en el grupo modificador que no corresponden con el modificador
          // foundPanel.opciones.forEach((opcionEnPanel, i) => {
          // 	let index = g.opciones.findIndex((op) => op.id == opcionEnPanel.id);

          // });
          return {
            mostrarCheck:
              !!this.keyManejando &&
              ((this.keyManejando.i_panel <= i &&
                this.keyManejando.tipo != "simple") ||
                (this.keyManejando.i_panel < i &&
                  this.keyManejando.tipo == "simple")),
            ...foundPanel,
            ...g,
            nombre: mostrarIdioma(foundPanel.nombre),
            opciones: g.opciones.map((op, j) => {
              let foundOpcion = opciones.find((m) => {
                let indexSubstring = op.id.indexOf("_");
                let idAux = op.id;
                let idBuscar = idAux.substring(indexSubstring + 1);
                return m.id == idBuscar.split("_")[0];
              });

              let foundInc =
                this.keyManejando &&
                this.keyManejando.incompatibilidades &&
                this.keyManejando.incompatibilidades.includes(op.id);
              return {
                ...foundOpcion,
                ...op,
                // ...foundOpcionEnModificador,
                // id:
                //   foundOpcionEnModificador &&
                //   foundOpcionEnModificador.id.indexOf("_") > -1
                //     ? foundOpcionEnModificador.id
                //     : randomString(4) + "_" + foundOpcion.id,
                manejando: false,
                linkColor: foundInc ? "red" : "green",
                linkPost:
                  this.keyManejando &&
                  this.keyManejando.i_panel == i &&
                  this.keyManejando.tipo != "simple" &&
                  this.keyManejando.i_opcion != j,
                linkPre:
                  this.keyManejando && this.keyManejando.i_panel < i
                    ? true
                    : false,
                ocultar: op && op.ocultar ? op.ocultar : false,
                defecto: op && op.defecto ? op.defecto : false,
                nombre: foundOpcion
                  ? mostrarIdioma(foundOpcion.nombre)
                  : "NO EXISTE, CAMBIAR",
              };
              // }
            }),
          };
        }
      });
      // console.log(res.filter((p) => !!p));
      return res.filter((p) => !!p);
    },
  },
  methods: {
    marcarDefecto(item, i, j) {
      console.log(item);
      console.log(this.grupoModificador);
      console.log(this.grupoModificador.modificadores[i].opciones[j]);
      this.grupoModificador.modificadores[i].opciones[j].defecto =
        !this.grupoModificador.modificadores[i].opciones[j].defecto;
    },
    marcarVisualNinguno(item) {
      let fI = this.grupoModificador.modificadores.findIndex(
        (g) => g.id == item.id
      );
      if (fI > -1) {
        this.grupoModificador.modificadores[fI] = {
          ...this.grupoModificador.modificadores[fI],
          opciones: this.grupoModificador.modificadores[fI].opciones.map(
            (op) => {
              return {
                ...op,
                ocultar: true,
              };
            }
          ),
        };
      }
    },
    marcarVisualTodos(item) {
      let fI = this.grupoModificador.modificadores.findIndex(
        (g) => g.id == item.id
      );
      if (fI > -1) {
        let modificadoresCambiar = JSON.parse(
          JSON.stringify(this.grupoModificador.modificadores)
        );
        modificadoresCambiar[fI] = {
          ...this.grupoModificador.modificadores[fI],
          opciones: this.grupoModificador.modificadores[fI].opciones.map(
            (op) => {
              return {
                ...op,
                ocultar: false,
              };
            }
          ),
        };
        this.grupoModificador = {
          ...this.grupoModificador,
          modificadores: modificadoresCambiar,
        };
      }
    },
    addOpcionConfirmarCrear() {
      let objAdd = {
        nombre: !!this.opcionAddNuevo.basado
          ? this.opcionAddNuevo.basado.nombre
          : [],
        tipo:
          !!this.opcionAddNuevo.basado && this.opcionAddNuevo.basado.tipo
            ? this.opcionAddNuevo.basado.tipo
            : "simple",
        max:
          !!this.opcionAddNuevo.basado && this.opcionAddNuevo.basado.max
            ? this.opcionAddNuevo.basado.max
            : null,
        min:
          !!this.opcionAddNuevo.basado && this.opcionAddNuevo.basado.min
            ? this.opcionAddNuevo.basado.min
            : null,
        descripcion: !!this.opcionAddNuevo.basado
          ? this.opcionAddNuevo.basado.descripcion
          : [],
        descripcionInterna: this.opcionAddNuevo.descInterna,
        opciones: !!this.opcionAddNuevo.basado
          ? this.opcionAddNuevo.basado.opciones.map((op) => {
              return {
                ...op,
              };
            })
          : [],
        id: null,
      };
      this.$store
        .dispatch("productos/addModificador", objAdd)
        .then((r) => {
          objAdd.id = r.id;
          return this.$store.dispatch("productos/getModificadores");
        })
        .then(() => {
          this.opcionAdd = objAdd;
        })
        .then(() => {
          this.addOpcionConfirmar();
          this.$forceUpdate();
          this.dialogAddOpcionNuevo = false;
        });
    },
    marcarIncompatiblesTodos(item) {
      item.opciones.map((op) => {
        if (
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades
        ) {
          let foundIndex = this.grupoModificadorComputed[
            this.keyManejando.i_panel
          ].opciones[this.keyManejando.i_opcion].incompatibilidades.findIndex(
            (i) => i == op.id
          );
          if (foundIndex > -1) {
            //la incopmatibilidad, la deejamos
          } else {
            this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
              this.keyManejando.i_opcion
            ].incompatibilidades.push(op.id);
          }
        } else {
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades = [op.id];
        }
      });
    },
    marcarIncompatiblesNinguno(item) {
      item.opciones.map((op) => {
        if (
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades
        ) {
          let foundIndex = this.grupoModificadorComputed[
            this.keyManejando.i_panel
          ].opciones[this.keyManejando.i_opcion].incompatibilidades.findIndex(
            (i) => i == op.id
          );
          if (foundIndex > -1) {
            this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
              this.keyManejando.i_opcion
            ].incompatibilidades.splice(foundIndex, 1);
          } else {
            //no está, no hacemeos nada
          }
        } else {
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades = [op.id];
        }
      });
    },
    async goModificador(item) {
      await this.save();
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/almacen/modificadores/form/" +
        item.id;
      this.$router.push(str);
    },
    borrarModificador(i) {
      this.grupoModificador.modificadores.splice(i, 1);
    },
    compaMarcarOpcion(i, i_a, op_select) {
      this.grupoModificadorComputed[i].opciones[i_a].manejando = true;
      // console.log(this.grupoModificadorComputed[i].opciones[i_a]);
      // console.log(op_select);
      op_select.i_panel = i;
      op_select.i_opcion = i_a;
      op_select.tipo = this.grupoModificadorComputed[i].tipo;
      this.keyManejando = op_select;
      // this.dibujarTablero(aux);
    },
    marcarOcultar(op, panel, opcion) {
      let grupos = [...this.grupoModificador.modificadores];
      // console.log(grupos);
      let fI = grupos[panel].opciones.findIndex((o) => o.id == op.id);
      if (fI > -1) {
        grupos[panel].opciones[fI].ocultar = !op.ocultar;
        // , = {
        //         ...this.grupoModificador.modificadores[panel].opciones[opcion],
        //         ocultar: !op.ocultar,
        //       };

        this.grupoModificador.modificadores = [...grupos];
      } else {
        grupos[panel].opciones.push({
          id: randomString(4) + "_" + op.id,
          incompatibilidades: [],
          ocultar: !op.ocultar,
        });
        this.grupoModificador.modificadores = [...grupos];
      }
    },
    marcarComp(op) {
      if (
        this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
          this.keyManejando.i_opcion
        ].incompatibilidades
      ) {
        let foundIndex = this.grupoModificadorComputed[
          this.keyManejando.i_panel
        ].opciones[this.keyManejando.i_opcion].incompatibilidades.findIndex(
          (i) => i == op.id
        );
        if (foundIndex > -1) {
          //la incopmatibilidad está, la quitamos
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades.splice(foundIndex, 1);
        } else {
          this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
            this.keyManejando.i_opcion
          ].incompatibilidades.push(op.id);
        }
      } else {
        this.grupoModificadorComputed[this.keyManejando.i_panel].opciones[
          this.keyManejando.i_opcion
        ].incompatibilidades = [op.id];
      }

      return;
      let op_select = this.keyManejando;
      if (op_select.incomp) {
        let found = op_select.incomp.find((e) => e == op.id);
        if (found) {
          this.removeA(op_select.incomp, op.id);
        } else {
          op_select.incomp.push(op.id);
        }
      } else {
        op_select.incomp = [op.id];
      }
      this.grupoModificador.modificadores[op_select.i_panel].opciones[
        op_select.i_opcion
      ] = op_select;
      this.keyManejando = op_select;
      // this.dibujarTablero(aux);
    },
    claseOpcion(op) {
      return op.manejando ? "info" : "";
    },
    mostrarLinkPre(i, i_a) {
      if (i == 0) {
        return false;
      }
      return true;
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    addOpcionBoton() {
      this.dialogAddOpcion = true;
    },
    addOpcionBotonNuevo() {
      this.dialogAddOpcionNuevo = true;
    },
    addOpcionConfirmar() {
      let i_panel = this.grupoModificador.modificadores.length;
      let f = this.$store.state.productos.gruposModificadores.find(
        (g) => g.id == this.opcionAddConfiguracion
      );

      var fPanel = f
        ? f.modificadores.find((fM) => fM.id == this.opcionAdd.id)
        : false;
      console.log(f);
      console.log(fPanel);

      let agregar = {
        id: this.opcionAdd.id,
        opciones: fPanel
          ? fPanel.opciones
          : this.opcionAdd.opciones.map((op, i_opcion) => {
              return {
                ...op,
                id: randomString(4) + "_" + op.id,
                incompatibilidades: [],
                ocultar: false,
              };
            }),
      };
      this.grupoModificador.modificadores.push(agregar);
      this.dialogAddOpcion = false;
    },
    goBack() {
      this.$router.go(-1);
      // let str =
      //   "/admin/gest/" + this.negocio.id + "/almacen/gruposmodificadores";
      // this.$router.push(str);
    },
    save() {
      this.loadingGuardar = true;
      this.loading = true;
      this.grupoModificador.modificadores.forEach((m) => {
        m.opciones.forEach((op) => {
          delete op.tarifas, delete op.manejando;
        });
      });

      this.$store
        .dispatch("productos/addGrupoModificador", { ...this.grupoModificador })
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Grupo Modificador guardado",
          });
          // this.goBack();
        })

        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el modificador: " + error,
          });
        })
        .finally(() => {
          this.loadingGuardar = false;
          this.loading = false;
        });
    },
    dragReorder({ oldIndex, newIndex }) {
      const movedItem = this.modificador.opciones.splice(oldIndex, 1)[0];
      this.modificador.opciones.splice(newIndex, 0, movedItem);
    },
    itemKey(item) {
      if (!this.itemKeys.has(item))
        this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    // adaptarOpciones() {
    //   //se adapta para ponerle una cadena aleatoria a la id y poder compartir opciones con el mismo id en el grupo modificador
    //   let aux = JSON.parse(JSON.stringify(this.grupoModificador));
    //   this.grupoModificador = {
    //     ...aux,
    //     modificadores: aux.modificadores.map((mod) => {
    //       return {
    //         ...mod,
    //         opciones: mod.opciones.map((op) => {
    //           var index = op.id.indexOf("_");
    //           console.log(index);
    //           return {
    //             ...op,
    //             id: index > -1 ? op.id : randomString(4) + "_" + op.id,
    //           };
    //         }),
    //       };
    //     }),
    //   };
    // },
    adaptarOpcionesMounted() {
      let modificadores = this.$store.state.productos.modificadores;

      var res = this.grupoModificador.modificadores
        .map((gMod) => {
          var foundMod = modificadores.find((mod) => gMod.id == mod.id);
          if (foundMod) {
            return {
              ...gMod,
              opciones: foundMod.opciones.map((op, i) => {
                var foundOpConcreto = gMod.opciones.find((opGmod) =>
                  opGmod.id.includes(op.id)
                );
                if (foundOpConcreto) {
                  //see encuentra, se incluye
                  foundOpConcreto.id =
                    foundOpConcreto.id.indexOf("_") > -1
                      ? foundOpConcreto.id
                      : randomString(4) + "_" + op.id;
                  return {
                    ...foundOpConcreto,
                  };
                } else {
                  return {
                    id: randomString(4) + "_" + op.id,
                    incompatibilidades: [],
                    ocultar: true,
                  };
                }
              }),
            };
          }
        })
        .filter((gm) => !!gm);

      this.grupoModificador.modificadores = res;
    },
  },
  mounted() {
    // new Sortable(
    //   this.$refs.sortableTable.$el.getElementsByTagName("tbody")[0],
    //   {
    //     draggable: ".sortableRow",
    //     handle: ".sortHandle",
    //     onEnd: this.dragReorder,
    //   }
    // );
    this.$store.dispatch("productos/getModificadores");
    this.$store.dispatch("productos/getGruposModificadores");
    if (this.$route.params.id) {
      //obtenemos modificador
      this.$store
        .dispatch("productos/getGrupoModificador", this.$route.params.id)
        .then((r) => {
          this.grupoModificador = {
            ...r,
          };
          this.adaptarOpcionesMounted();
          // this.dibujarTablero(r);
        });
    } else {
    }
  },
};
</script>

<style>
</style>